import commercialHierarchy from '@/mixins/commercialHierarchy'
import { Flavors } from '../../plugins/constants'
import { notification } from '../../plugins/helpers'
import validarVigenciaPontosDeVenda from './validarVigenciaPontosDeVenda'
import { AlertTypes } from '../../plugins/alerts_types'
const UNIDADE_NEGOCIO_PADRAO_HIERARQUIA = -1
export default {
  data: () => ({
    entrando_fluxo_venda: false,
    indo_para_rota: '',
    modal_hierarquia_estrutura_entrando_venda: false,
    modal_hierarquia_ponto_venda_entrando_venda: false,
    modal_hierarquia_comissionado_entrando_venda: false,
    modalEscolherAmbienteFluxoVendas: false,
    ambientes_comissionado: []
  }),
  mixins: [commercialHierarchy, validarVigenciaPontosDeVenda],
  methods: {
    async entrarFluxoVendasHierarquiaComercial (rota_recebida = false) {
      this.resetarPadroes(rota_recebida)
      try {
        if (!this.validarEstruturaEntrandoVenda()) {
          this.modal_hierarquia_estrutura_entrando_venda = true
          return
        }
        if (!this.validarPontosDeVenda()) {
          return
        }
        if (!this.validarPontoVendaEntrandoVenda()) {
          this.modal_hierarquia_ponto_venda_entrando_venda = true
          return
        }
        if (!this.validarComissionadoEntrandoVenda()) {
          this.modal_hierarquia_comissionado_entrando_venda = true
          return
        }
        const id_comissionado = this.$session.get('id_comissionado_venda')
        const id_ponto_venda = this.$session.get('id_ponto_venda')
        this.ambientes_comissionado = await this.buscarAmbientesComissionadoPorUnidadeNegocio(id_comissionado, id_ponto_venda)
        this.modalEscolherAmbienteFluxoVendas = true
        this.entrando_fluxo_venda = false
      } catch (err) {
        this.resetarEstruturaComercial()
        this.resetarFlavor()
        this.resetarUnidadeNegocio()
        const dataFimVigencia = this.$session.get('data_fim_vigencia')
        if (this.isVigenciaFechada(dataFimVigencia)) {
          notification(AlertTypes.ERROR, 'O Ponto de Venda selecionado está com a vigência fechada e por isso não é possível lançar vendas no mesmo. Por favor, entre em contato com a Área de Suporte')
        } else {
          notification(AlertTypes.ERROR, 'Não foi possível carregar os ambientes da estrutura, comissionado ou ponto de venda. Por favor tente novamente em instantes, caso o erro persistir, entre em contato com a Área de Suporte.')
        }
        this.setarEntrandoVenda(false)
      }
    },
    resetarPadroes (rota_recebida) {
      if (rota_recebida) {
        this.entrando_fluxo_venda = true
        this.indo_para_rota = rota_recebida
      }
      this.ambientes_comissionado = []
    },
    validarEstruturaEntrandoVenda () {
      return this.hierarquia_comercial?.estruturaComercialSelecionada?.idEstruturaComercial > 0
    },
    validarPontoVendaEntrandoVenda () {
      const idPontoVendaSessao = this.$session.get('id_ponto_venda')
      return idPontoVendaSessao && idPontoVendaSessao > 0
    },
    validarComissionadoEntrandoVenda () {
      const idComissionadoSessao = this.$session.get('id_comissionado_venda')
      return idComissionadoSessao && idComissionadoSessao > 0
    },
    resetarFlavor () {
      this.$session.set('flavor', Flavors.ED)
    },
    resetarUnidadeNegocio () {
      this.$session.set('id_unidade_negocio', UNIDADE_NEGOCIO_PADRAO_HIERARQUIA)
    },
    async buscarAmbientesComissionadoPorUnidadeNegocio (id_comissionado, id_ponto_venda) {
      return this.$http.get(`/ambientes_por_comissionado/${id_comissionado}/${id_ponto_venda}`).then((response) => {
        return response.data.ambientes
      }).catch((err) => {
        // Tratamento específico para erros conhecidos
        if (err.response && err.response.data) {
          const errorData = err.response.data
          if (errorData.error === 'PONTO_VENDA_NAO_VINCULADO') {
            const pontosDisponiveis = errorData.pontos_venda_disponiveis?.join(', ') || 'nenhum'
            notification(AlertTypes.ERROR, `O ponto de venda selecionado não está vinculado a este comissionado. Pontos de venda disponíveis: ${pontosDisponiveis}`)
            throw new Error('PONTO_VENDA_NAO_VINCULADO')
          }
          if (errorData.error === 'COMISSIONADO_SEM_PONTOS_VENDA') {
            notification(AlertTypes.ERROR, 'Este comissionado não possui pontos de venda cadastrados no sistema. Por favor, entre em contato com a Área de Suporte.')
            throw new Error('COMISSIONADO_SEM_PONTOS_VENDA')
          }
        }
        throw err
      })
    },
    setarEntrandoVenda (val) {
      if (!val) {
        this.modal_hierarquia_estrutura_entrando_venda = false
        this.modal_hierarquia_ponto_venda_entrando_venda = false
        this.modal_hierarquia_comissionado_entrando_venda = false
        this.modalEscolherAmbienteFluxoVendas = false
      }
      this.entrando_fluxo_venda = val
    }
  }
}
